"use client";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <html>
            <head>
                <title>Something went wrong | Contract Rabbit</title>
                <style
                    dangerouslySetInnerHTML={{
                        __html: `
                            @keyframes gradient-x {
                                0%, 100% { background-position: 0% 50%; }
                                50% { background-position: 100% 50%; }
                            }
                            .animate-gradient { animation: gradient-x 15s ease infinite; background-size: 200% 200%; }
                        `,
                    }}
                />
            </head>
            <body style={{ margin: 0, fontFamily: "system-ui, -apple-system, sans-serif" }}>
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        minHeight: "100vh",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "#fafafa",
                    }}
                >
                    <div
                        className="animate-gradient"
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(90deg, rgba(226, 232, 240, 0.5), rgba(191, 219, 254, 0.3), rgba(226, 232, 240, 0.5))",
                        }}
                    />
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "28rem",
                            margin: "1rem",
                            borderRadius: "1rem",
                            border: "1px solid #e5e7eb",
                            backgroundColor: "white",
                            padding: "2rem",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <div
                            style={{
                                margin: "0 auto",
                                display: "flex",
                                height: "5rem",
                                width: "6rem",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img
                                src="/contract-rabbit-logo-main.png"
                                alt="Contract Rabbit"
                                width={88}
                                height={72}
                                style={{ display: "block", width: 88, height: 72, objectFit: "contain" }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
                            <h1 style={{ fontSize: "1.5rem", fontWeight: 600, color: "#111827", margin: 0 }}>
                                Something went wrong
                            </h1>
                            <p style={{ marginTop: "0.75rem", fontSize: "0.875rem", color: "#6b7280" }}>
                                An unexpected error occurred. Our team has been notified.
                            </p>
                            {error.digest && (
                                <p
                                    style={{
                                        marginTop: "0.5rem",
                                        fontFamily: "monospace",
                                        fontSize: "0.75rem",
                                        color: "#9ca3af",
                                    }}
                                >
                                    Error ID: {error.digest}
                                </p>
                            )}
                            <div
                                style={{
                                    marginTop: "1.5rem",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.75rem",
                                }}
                            >
                                <button
                                    onClick={() => reset()}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "0.5rem",
                                        background: "#3b82f6",
                                        padding: "0.625rem 1.25rem",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        color: "white",
                                        border: "none",
                                        cursor: "pointer",
                                        boxShadow: "0 10px 15px -3px rgba(59, 130, 246, 0.25)",
                                    }}
                                >
                                    Try Again
                                </button>
                                <button
                                    onClick={() => window.location.assign("/")}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "0.5rem",
                                        border: "1px solid #e5e7eb",
                                        backgroundColor: "white",
                                        padding: "0.625rem 1.25rem",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        color: "#374151",
                                        cursor: "pointer",
                                    }}
                                >
                                    Go Home
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    );
}
